import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const ScoringToolContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 300px;
  height: 332px;
  background-color: ${Color.greyF5F5F5};
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 25px 15px;

  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background-color: ${ColorDark.greySeparator};
    }
  }
  .btn-close {
    border: none;
    background-color: ${Color.greyF5F5F5};
    position: absolute;
    right: -30px;
    top: 0;
    cursor: pointer;
    width: 32px;
    height: 32px;
    padding-top: 4px;
    padding-left: 7px;
    :hover {
      opacity: 0.8;
    }
    svg {
      fill: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          fill: ${ColorDark.textLight};
        }
      }
    }
  }
  .title {
    ${Font.sansRegular};
    font-size: 11px;
    line-height: 25px;
    color: ${Color.grey};
    text-transform: uppercase;
    margin-top: 25px;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  .contentBottom {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const StarFunction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  p {
    ${Font.sansRegular};
    font-size: 11px;
    line-height: 25px;
    color: ${Color.grey};
    text-transform: uppercase;
    text-align: center;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }
  }
  button {
    width: 100px;
    height: 44px;
    background-color: ${Color.grey};
    border-radius: 50px;
    border: none;
    color: white;
    margin-top: 12px;
    cursor: pointer;
    :hover {
      color: ${Color.mainColor};
    }
  }
`;

export const StarReference = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 0;
  margin-top: 4px;
  .star-ref {
    display: flex;
    flex-direction: row;
    column-gap: 30px;
    justify-content: flex-end;
    p {
      ${Font.sansRegular};
      font-size: 15px;
      line-height: 20px;
      color: ${Color.grey999};
      min-width: 120px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .star-amount {
      display: flex;
      flex-direction: row;
      column-gap: 6px;
      align-items: center;
      svg {
        fill: ${Color.grey999};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            fill: ${ColorDark.textLight};
          }
        }
      }
    }
  }
`;
export const StarListScore = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.3rem;
  margin-top: 6px;

  .star-icon svg {
    fill: white;
    stroke: ${Color.grey};
    stroke-width: 25px;
    cursor: pointer;
    :hover {
      fill: ${Color.mainColor};
      stroke: ${Color.mainColor};
    }
  }
`;
